import React from "react";
import "../../assets/css/Loader.css";

export default function LineLoader({ progress }) {
    return (
        <div className="line-loader-wrapper">
            <div
                className="line-loader-fill"
                style={{ width: `${progress}%` }}
            />
        </div>
    );
}
